import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  IconButton,
  Divider,
  Tooltip,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Menu, ChevronLeft, Article, PostAdd, Redo } from "@mui/icons-material";

const Sidebar = ({ collapsed, onToggleCollapse }) => {
  const menuItems = [
    { text: "Статьи", path: "/admin/articles", icon: <Article /> },
    { text: "Редиректы", path: "/admin/redirects", icon: <Redo /> },
    {
      text: "Создать статью",
      path: "/admin/articles/create",
      icon: <PostAdd />,
    },
  ];

  return (
    <Box
      component="nav"
      sx={{
        width: collapsed ? 60 : 200,
        flexShrink: 0,
        position: "fixed",
        height: "100vh",
        borderRight: "1px solid #e0e0e0",
        bgcolor: "background.paper",
        transition: "width 0.3s ease",
        overflow: "hidden",
        zIndex: 1,
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
        <Tooltip title={collapsed ? "Развернуть" : "Свернуть"}>
          <IconButton onClick={onToggleCollapse}>
            {collapsed ? <Menu /> : <ChevronLeft />}
          </IconButton>
        </Tooltip>
      </Box>

      <Divider />

      <List>
        {menuItems.map((item) => (
          <ListItem
            key={item.text}
            disablePadding
          >
            <Tooltip
              title={collapsed ? item.text : ""}
              placement="right"
            >
              <ListItemButton
                component={Link}
                to={item.path}
                sx={{
                  minHeight: 40,
                  justifyContent: collapsed ? "center" : "initial",
                  px: 2.5,
                }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 0 : 3 }}>{item.icon}</ListItemIcon>
                <ListItemText
                  primary={item.text}
                  sx={{
                    opacity: collapsed ? 0 : 1,
                    transition: "opacity 0.2s",
                  }}
                />
              </ListItemButton>
            </Tooltip>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default Sidebar;
